import { render, staticRenderFns } from "./globalMenuItem.vue?vue&type=template&id=5f3c6b26&"
import script from "./globalMenuItem.vue?vue&type=script&lang=ts&"
export * from "./globalMenuItem.vue?vue&type=script&lang=ts&"
import style0 from "./globalMenuItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports